/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPaymentTemplate} from '../api'

 export const useQueryGetPaymentTemplate = createReactQueryHook('getPaymentTemplate', getPaymentTemplate)
